module.exports = __webpack_public_path__ + "img/active-17.464a9c69.svg";